module.exports = __webpack_public_path__ + "static/media/esl.c49b06a2.png";